import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8p6hzrhexg: FaireBrandEntity = {
  token: "b_8p6hzrhexg",
  type: "brand",
  name: "AK Brand",
  avatarUrl:
    "https://cdn.faire.com/fastly/04223389b032785fc37a8619a8f96e5faddadff3eae792ac94c5d095fb3dc787.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d0bc94ccc0cadc9a47fab91e0fa852c9955bf5fdff43eb7d11303bdd01cc896b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/04223389b032785fc37a8619a8f96e5faddadff3eae792ac94c5d095fb3dc787.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0bc94ccc0cadc9a47fab91e0fa852c9955bf5fdff43eb7d11303bdd01cc896b.jpeg",
  location: "Anaheim, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.1,
  reviewCount: 49,
  isTopShop: true,
  isInsider: true,
  description:
    "The AK brand, started in southern California in 2013 as a fashion label with a vision to create true-quality pieces for all.\n\nThough its full name is Anna-Kaci, the symbols AK focuses and stands for true-quality contemporary jewelry, fashion accessories, and chic women's clothing made to help you keep up with the ever-changing trends.\n\nIt's knowing you're getting something that will fashionably top off your look and last from outfit to outfit — that's what exemplifies true-quality.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:09.456Z",
    importedBy: "entity-db-cli",
  },
};
